module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-text-fill-2c737b62.svg";